import './index.css';
import logo from '../../logo.svg'

function UserInfo(props) {

    let userInfo = props.userInfo
    if (!userInfo) {
        userInfo = {} 
    }

    return (
        <div className='userinfo'>
           <div><img className='avatar' src= {userInfo.avatar_url || logo} alt='' /> </div> 
            <div>
                <div className='name'>{ userInfo.name && userInfo.name.length > 0 ? '欢迎来到澳多管车' : ''}</div>
                <div className='welcome'>{userInfo.name && userInfo.name.length > 0 ?  '一键预约，审批快速，用车安排明确，公务出行更安心' : ''}</div>
            </div>
            
        </div>
    );
}

export default UserInfo;
